module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/notification/notification.html
// module id = 752
// module chunks = 0